import { render } from "./ManageBrand.vue?vue&type=template&id=07985c08"
import script from "./ManageBrand.vue?vue&type=script&lang=js"
export * from "./ManageBrand.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__